import axios from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { FileRecordNew, FileStatusEnum } from '../types/file-record';

type ReplaceDocumentRequest = {
    replacingDocument: File;
    currentRecord: FileRecordNew;
    renameReferences: boolean;
};

const isMock = process.env.REACT_APP_MOCK_USER === 'true';

export type ReplacePresignedPutUrlRequest = { recordId: string; fileType: string };

async function replaceDocument({ replacingDocument, currentRecord, renameReferences }: ReplaceDocumentRequest): Promise<void> {
    const { data } = await api.get(`/file-records/documents/${currentRecord.id}/replace`);

    // Special use case where we need to use the default axios instance to upload to s3
    await axios.put(data.url, replacingDocument, {
        headers: {
            // 'Content-Type': 'application/octet-stream',
            'Content-Type': isMock ? 'application/octet-stream' : 'multipart/form-data',
        },
    });

    await api.patch('/file-records', [
        {
            id: currentRecord.id,
            fields: {
                name: replacingDocument.name,
                mimeType: replacingDocument.type,
                bytes: replacingDocument.size,
                status: FileStatusEnum.CHECKED_IN,
            },
            updateReferences: renameReferences,
        },
    ]);
}

export function useReplaceDocument(): UseMutationResult<void, unknown, ReplaceDocumentRequest, unknown> {
    return useMutation(replaceDocument, {
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
